import { Grid, styled } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';

export const ScoringTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.grey[600],
    color: theme.palette.grey[600]
  }
}));

export const ScoringGridContainer = styled(Grid)(() => ({
  display: 'block'
}));
